
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Response} from '../core/Response';
import {FieldModelResponse} from '../core/Response';
import {ChartBarsImportInfo} from './ChartBarsImportInfo';
import {FieldModelChartBarsImportInfo} from './ChartBarsImportInfo';

/**
 * ChartBarsImportResponse struct
 */
class ChartBarsImportResponse extends Response {
  /**
   * Initialize struct
   * @param {!Response=} parent
   * @param {!Array=} importBarsInfo
   * @param {!Set=} importSymbolsSucceed
   * @param {!Set=} importSymbolsFailed
   * @constructor
   */
  constructor (parent = new Response(), importBarsInfo = [], importSymbolsSucceed = new Set(), importSymbolsFailed = new Set()) {
    super()
    super.copy(parent)
    this.ImportBarsInfo = importBarsInfo
    this.ImportSymbolsSucceed = importSymbolsSucceed
    this.ImportSymbolsFailed = importSymbolsFailed
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ChartBarsImportResponse}
   * @param {!ChartBarsImportResponse} other Other struct
   * @returns {!ChartBarsImportResponse} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.ImportBarsInfo != null) {
      this.ImportBarsInfo = []
      for (let item of other.ImportBarsInfo) {
        if (item != null) {
          let tempItem
          tempItem = ChartBarsImportInfo.fromObject(item)
          this.ImportBarsInfo.push(tempItem)
        } else {
          this.ImportBarsInfo.push(null)
        }
      }
    } else {
      this.ImportBarsInfo = null
    }
    if (other.ImportSymbolsSucceed != null) {
      this.ImportSymbolsSucceed = new Set()
      for (let item of other.ImportSymbolsSucceed) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.ImportSymbolsSucceed.add(tempItem)
        } else {
          this.ImportSymbolsSucceed.add(null)
        }
      }
    } else {
      this.ImportSymbolsSucceed = null
    }
    if (other.ImportSymbolsFailed != null) {
      this.ImportSymbolsFailed = new Set()
      for (let item of other.ImportSymbolsFailed) {
        if (item != null) {
          let tempItem
          tempItem = item
          this.ImportSymbolsFailed.add(tempItem)
        } else {
          this.ImportSymbolsFailed.add(null)
        }
      }
    } else {
      this.ImportSymbolsFailed = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ChartBarsImportResponse}
   * @returns {!ChartBarsImportResponse} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ChartBarsImportResponseModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ChartBarsImportResponseModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ChartBarsImportResponse}
   * @param {!ChartBarsImportResponse} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ChartBarsImportResponse)) {
      throw new TypeError('Instance of ChartBarsImportResponse is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ChartBarsImportResponse}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      ImportBarsInfo: ((this.ImportBarsInfo != null) ? Array.from(this.ImportBarsInfo, item => ((item != null) ? item : null)) : null),
      ImportSymbolsSucceed: ((this.ImportSymbolsSucceed != null) ? Array.from(this.ImportSymbolsSucceed, item => ((item != null) ? item : null)) : null),
      ImportSymbolsFailed: ((this.ImportSymbolsFailed != null) ? Array.from(this.ImportSymbolsFailed, item => ((item != null) ? item : null)) : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ChartBarsImportResponse.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ChartBarsImportResponse} other Object value
   * @returns {!ChartBarsImportResponse} Created struct
   */
  static fromObject (other) {
    return new ChartBarsImportResponse().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ChartBarsImportResponse}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ChartBarsImportResponse.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ChartBarsImportResponse}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3023
  }
}

export { ChartBarsImportResponse };

/**
 * Fast Binary Encoding ChartBarsImportResponse field model
 */
class FieldModelChartBarsImportResponse extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelResponse(buffer, 4 + 4)
    this.ImportBarsInfo = new fbe.FieldModelVector(new FieldModelChartBarsImportInfo(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4), buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ImportSymbolsSucceed = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.ImportBarsInfo.fbeOffset + this.ImportBarsInfo.fbeSize), buffer, this.ImportBarsInfo.fbeOffset + this.ImportBarsInfo.fbeSize)
    this.ImportSymbolsFailed = new fbe.FieldModelSet(new fbe.FieldModelString(buffer, this.ImportSymbolsSucceed.fbeOffset + this.ImportSymbolsSucceed.fbeSize), buffer, this.ImportSymbolsSucceed.fbeOffset + this.ImportSymbolsSucceed.fbeSize)
  }

  /**
   * Get the core.Response field model
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!FieldModelResponse} core.Response field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.ImportBarsInfo.fbeSize + this.ImportSymbolsSucceed.fbeSize + this.ImportSymbolsFailed.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.ImportBarsInfo.fbeExtra + this.ImportSymbolsSucceed.fbeExtra + this.ImportSymbolsFailed.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelChartBarsImportResponse.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3023
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ImportBarsInfo.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ImportBarsInfo.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ImportBarsInfo.fbeSize

    if ((fbeCurrentSize + this.ImportSymbolsSucceed.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ImportSymbolsSucceed.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ImportSymbolsSucceed.fbeSize

    if ((fbeCurrentSize + this.ImportSymbolsFailed.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ImportSymbolsFailed.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ImportSymbolsFailed.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!ChartBarsImportResponse} fbeValue Default value, defaults is new ChartBarsImportResponse()
   * @returns {!ChartBarsImportResponse} ChartBarsImportResponse value
   */
  get (fbeValue = new ChartBarsImportResponse()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!ChartBarsImportResponse} fbeValue ChartBarsImportResponse value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.ImportBarsInfo.fbeSize) <= fbeStructSize) {
      this.ImportBarsInfo.get(fbeValue.ImportBarsInfo)
    } else {
      fbeValue.ImportBarsInfo.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ImportBarsInfo.fbeSize

    if ((fbeCurrentSize + this.ImportSymbolsSucceed.fbeSize) <= fbeStructSize) {
      this.ImportSymbolsSucceed.get(fbeValue.ImportSymbolsSucceed)
    } else {
      fbeValue.ImportSymbolsSucceed.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ImportSymbolsSucceed.fbeSize

    if ((fbeCurrentSize + this.ImportSymbolsFailed.fbeSize) <= fbeStructSize) {
      this.ImportSymbolsFailed.get(fbeValue.ImportSymbolsFailed)
    } else {
      fbeValue.ImportSymbolsFailed.clear()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ImportSymbolsFailed.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelChartBarsImportResponse}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelChartBarsImportResponse}
   * @param {!ChartBarsImportResponse} fbeValue ChartBarsImportResponse value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelChartBarsImportResponse}
   * @param {ChartBarsImportResponse} fbeValue ChartBarsImportResponse value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.ImportBarsInfo.set(fbeValue.ImportBarsInfo)
    this.ImportSymbolsSucceed.set(fbeValue.ImportSymbolsSucceed)
    this.ImportSymbolsFailed.set(fbeValue.ImportSymbolsFailed)
  }
}

export { FieldModelChartBarsImportResponse };

/**
 * Fast Binary Encoding ChartBarsImportResponse model
 */
class ChartBarsImportResponseModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelChartBarsImportResponse(this.buffer, 4)
  }

  /**
   * Get the ChartBarsImportResponse model
   * @this {!ChartBarsImportResponseModel}
   * @returns {!FieldModelChartBarsImportResponse} model ChartBarsImportResponse model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ChartBarsImportResponseModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ChartBarsImportResponseModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ChartBarsImportResponseModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ChartBarsImportResponseModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelChartBarsImportResponse.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ChartBarsImportResponseModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ChartBarsImportResponseModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ChartBarsImportResponseModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ChartBarsImportResponseModel}
   * @param {!ChartBarsImportResponse} value ChartBarsImportResponse value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ChartBarsImportResponseModel}
   * @param {!ChartBarsImportResponse} value ChartBarsImportResponse value, defaults is new ChartBarsImportResponse()
   * @return {!object} Deserialized ChartBarsImportResponse value and its size
   */
  deserialize (value = new ChartBarsImportResponse()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ChartBarsImportResponse(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ChartBarsImportResponse(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ChartBarsImportResponseModel}
   * @param {!number} prev Previous ChartBarsImportResponse model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ChartBarsImportResponseModel };
